module.exports = __webpack_public_path__ + "static/media/user-edit.c6850bd3.svg";